'use client';

import type { BillingPeriod } from './types';

interface Props {
  value: BillingPeriod;
  onChange: (v: BillingPeriod) => void;
  savingsLabel?: string;
}

/**
 * Pill-style billing toggle. Monthly is the default (set by parent).
 * The savings chip is integrated into the Yearly button so the message
 * doesn't get lost in a separate caption. Callers can supply exact savings.
 */
export default function BillingToggle({ value, onChange, savingsLabel = 'Save 2 months' }: Props) {
  return (
    <div className="inline-flex items-center rounded-full bg-slate-100 p-1 shadow-inner">
      <button
        type="button"
        onClick={() => onChange('monthly')}
        className={`relative rounded-full px-5 py-2 text-sm font-medium transition-colors ${
          value === 'monthly'
            ? 'bg-white text-slate-900 shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        }`}
      >
        Monthly
      </button>
      <button
        type="button"
        onClick={() => onChange('yearly')}
        className={`relative rounded-full px-5 py-2 text-sm font-medium transition-colors ${
          value === 'yearly'
            ? 'bg-white text-slate-900 shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        }`}
      >
        Yearly
        <span
          className={`ml-2 rounded-full bg-emerald-100 px-2 py-0.5 text-[11px] font-semibold tracking-wide text-emerald-700 ${
            value === 'yearly' ? '' : 'opacity-70'
          }`}
        >
          {savingsLabel}
        </span>
      </button>
    </div>
  );
}
